import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "menCountInput",
    "womenCountInput",
    "totalCountInput",
    "containsMenFields",
    "containsWomenFields",
  ];

  connect() {
    this.updateTotalCount();

    this.menCountInputTarget.addEventListener("blur", () => {
      if (this.menCountInputTarget.value === "0") {
        this._nullifyGroupFields(this.containsMenFieldsTargets);
      }
    });

    this.womenCountInputTarget.addEventListener("blur", () => {
      if (this.womenCountInputTarget.value === "0") {
        this._nullifyGroupFields(this.containsWomenFieldsTargets);
      }
    });
  }

  updateTotalCount() {
    const menCount = parseInt(this.menCountInputTarget.value) || 0;
    const womenCount = parseInt(this.womenCountInputTarget.value) || 0;
    const totalCount = menCount + womenCount;

    this.totalCountInputTarget.value = totalCount;

    this._toggleGroupFields(this.containsMenFieldsTargets, menCount > 0);
    this._toggleGroupFields(this.containsWomenFieldsTargets, womenCount > 0);
  }

  _toggleGroupFields(targets, enable) {
    targets.forEach((target) => {
      target.querySelectorAll("input").forEach((input) => {
        if (enable) {
          input.removeAttribute("disabled");
        } else {
          input.setAttribute("disabled", "true");
        }
      });
    });
  }

  _nullifyGroupFields(targets) {
    targets.forEach((target) => {
      target.querySelectorAll("input").forEach((input) => {
        input.value = "0";
      });
    });
  }
}
